export const tableHeader = [
    {
        id: 'name',
        type: 'text',
        value: 'Nome',
    },
    {
        id: 'criticity',
        type: 'select',
        value: 'Criticidade',
        render: (value, item) => {
            const criticity = value || item?.criticity;
            if (!criticity) return '-';
            
            const getCriticityColor = (level) => {
                const colors = {
                    '1': '#22c55e', // Verde
                    '2': '#84cc16', // Verde claro
                    '3': '#eab308', // Amarelo
                    '4': '#f97316', // Laranja
                    '5': '#ef4444'  // Vermelho
                };
                return colors[level] || '#6b7280';
            };
            
            const getCriticityLabel = (level) => {
                const labels = {
                    '1': '1 - Muito Baixa',
                    '2': '2 - Baixa',
                    '3': '3 - Média',
                    '4': '4 - Alta',
                    '5': '5 - Muito Alta'
                };
                return labels[level] || level;
            };
            
            return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div 
                        style={{
                            width: '12px',
                            height: '12px',
                            borderRadius: '50%',
                            backgroundColor: getCriticityColor(criticity),
                            border: '1px solid rgba(0,0,0,0.1)'
                        }}
                    />
                    <span>{getCriticityLabel(criticity)}</span>
                </div>
            );
        }
    },
    {
        id: 'saas',
        type: 'boolean',
        value: 'SaaS',
    },
    {
        id: 'developedInHouse',
        type: 'boolean',
        value: 'Desenvolvido internamente',
    },
    {
        id: 'user',
        type: 'text',
        value: 'Responsável',
    },
    {
        id: 'action',
        type: 'actions',
        value: '',
    },
]
